import React, { useState } from "react";
import api from "../../api/axios";
import { Button, Stack } from "@mui/material";
import ReportFilterBar from "../../components/reports/ReportFilterBar";
import ReportTable from "../../components/reports/ReportTable";

export default function DailyEODReport() {

  const [rows, setRows] = useState([]);

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    user: ""
  });

  const fetchData = async () => {
    try {

      const res = await api.get("/api/reports/my-eod", {
        params: filters
      });

      console.log("EOD API RESPONSE:", res.data);

      let data = [];

      // handle different response formats
      if (Array.isArray(res.data)) {
        data = res.data;
      }
      else if (Array.isArray(res.data.activities)) {
        data = res.data.activities;
      }
      else if (Array.isArray(res.data.data)) {
        data = res.data.data;
      }
      else if (Array.isArray(res.data.rows)) {
        data = res.data.rows;
      }

      setRows(data);

    } catch (err) {
      console.error("EOD Fetch Error:", err);
      setRows([]);
    }
  };

  const exportExcel = () => {

    const url =
      `http://localhost:5000/api/reports/my-eod/export` +
      `?startDate=${filters.startDate || ""}` +
      `&endDate=${filters.endDate || ""}` +
      `&user=${filters.user || ""}` +
      `&format=excel`;

    window.open(url, "_blank");
  };

  const exportPDF = () => {

    const url =
      `http://localhost:5000/api/reports/my-eod/export` +
      `?startDate=${filters.startDate || ""}` +
      `&endDate=${filters.endDate || ""}` +
      `&user=${filters.user || ""}` +
      `&format=pdf`;

    window.open(url, "_blank");
  };

  const columns = [
    { field: "date", header: "Date" },
    { field: "user", header: "User" },
    { field: "project", header: "Project" },
    { field: "work_item", header: "Work Item" },
    { field: "hours", header: "Hours" }
  ];

  return (
    <>
      <h2>Daily EOD Report</h2>

      <ReportFilterBar
        filters={["startDate", "endDate", "user"]}
        values={filters}
        onChange={setFilters}
        onFetch={fetchData}
      />

      <Stack direction="row" spacing={2} sx={{ marginTop: 2 }}>
        <Button variant="outlined" onClick={exportExcel}>
          Export Excel
        </Button>

        <Button variant="outlined" onClick={exportPDF}>
          Export PDF
        </Button>
      </Stack>

      <ReportTable
        columns={columns}
        rows={rows}
      />
    </>
  );
}